<template>
    <div class="public-ask-for-quote-layout">
        <div class="meta">
            <meta-logo/>
            <div class="meta--nav">
                <nav>
                    <ul>
                        <li><a href="tel:+4922739537362">
                            <svg-vue icon="support-headphones" class="icon"/>
                            <translate>+ 49 (0) 2273 95 373 62</translate>
                        </a></li>
                        <li>
                            <Link :href="$$route('register.email')">
                                <svg-vue icon="lock-shield-prote" class="icon"/>
                                <translate>Registrieren</translate>
                            </Link>
                        </li>
                        <li>
                            <Link :href="$$route('login')">
                                <svg-vue icon="lock-shield-prote" class="icon"/>
                                <translate>Login</translate>
                            </Link>
                        </li>
                        <li>
                            <language-selector/>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="public-ask-for-quote-layout--panel">
            <div class="public-ask-for-quote-layout--panel-inner">
                <slot></slot>
            </div>
        </div>
        <socket-nav/>
    </div>
</template>

<script>
import MetaLogo from '@partfactory/Shared/Header/MetaLogo';
import SocketNav from '@partfactory/Shared/Socket/SocketNav';
import {Link} from '@inertiajs/vue3';
import LanguageSelector from '@partfactory/Shared/LanguageSelector.vue';

export default {
    name: 'PublicAskForQuoteLayout',
    components: {
        LanguageSelector, Link,
        SocketNav,
        MetaLogo,
    }
};
</script>

